import { Component, EventEmitter, Output } from '@angular/core';
import { QuoteType } from '@models/models';

@Component({
	selector: 'add-quote-type-modal',
	template: require('./add-quote-type-modal.component.html')
})
export class AddQuoteTypeModalComponent {
	@Output()
	onQuoteTypeSelected: EventEmitter<QuoteType> = new EventEmitter<QuoteType>();

	constructor() {}

	emitQuoteType(quoteType: QuoteType): void {
		this.onQuoteTypeSelected.next(quoteType);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quotes/modals/add-quote-type-modal/add-quote-type-modal.component.ts